<template>
  <div class="mobile-nav hide-desktop">
    <router-link to="/"
      ><img alt="EVAPAPA" class="mobile-logo" src="../assets/logo800.gif" />
    </router-link>
    <div class="menu-btn" ref="menuButton" v-on:click="toggleMenu">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
    </div>
    <transition name="menu">
      <div v-if="menuOpen" class="mobile-nav-inner">
        <nav class="nav-link-container">
          <router-link class="nav-item" to="/">HOME</router-link>
          <router-link class="nav-item" to="/about">ABOUT</router-link>
          <router-link class="nav-item" to="/contact">CONTACT</router-link>
          <router-link class="nav-item" to="/portfolio">PORTFOLIO</router-link>
        </nav>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MobileNav",
  data: function() {
    return {
      menuOpen: false
    };
  },
  methods: {
    toggleMenu: function() {
      this.$refs.menuButton.classList.toggle("change");
      this.menuOpen = !this.menuOpen;
    }
  }
};
</script>
